import React, { useState } from "react";
import { Flex, Text, Button, Link } from "@jsq/ds/core";
import { Form, FormRadioButton, FormRadioGroup, SubmitButton } from "@jsq/ds/forms";
import { ownerThresholdSchema } from "./schemas";
import { FormValues, initialValues, OwnerThresholdProps } from "./types";

const OwnerThresholdFormContent: React.FC<{
  entityName: string;
  thresholdPercentage: number;
}> = ({ entityName, thresholdPercentage }) => {
  return (
    <FormRadioGroup
      name="ownerThresholdQuestion"
      label={`Do any individuals or entities own ${thresholdPercentage}% or more of the equity interests of ${entityName}`}
    >
      <FormRadioButton value="yes" id="yes" name="yes" key={0}>
        {"Yes"}
      </FormRadioButton>
      <FormRadioButton value="no" id="no" name="no" key={1}>
        {"No"}
      </FormRadioButton>
    </FormRadioGroup>
  );
};

export const OwnerThreshold: React.FC<OwnerThresholdProps> = (props: OwnerThresholdProps) => {
  const [thresholdMet, setThresholdMet] = useState<boolean | null>(null);

  const handleSubmit = (values: FormValues) => {
    const isThresholdMet = values.ownerThresholdQuestion === "yes" ? true : false;
    setThresholdMet(isThresholdMet);
    isThresholdMet && props.onContinue(isThresholdMet);
  };

  const handleBack = () => {
    props.onBack();
  };

  return (
    <Flex flexDirection="column" gap="20px">
      {props.entityName && (
        <Link
          to=""
          variant="muted"
          icon="arrow-left"
          iconPosition="left"
          align="left"
          onClick={handleBack}
        >
          {props.entityName}
        </Link>
      )}
      <Text variant="h3">{`Owners of ${props.entityName}`}</Text>

      {thresholdMet === false ? (
        <>
          <Text>
            {`Since no individuals or entities own ${props.thresholdPercentage}% or more of the equity interests of ${props.entityName}, you may continue to enter controllers`}
          </Text>
          <Flex justifyContent="flex-end" gap={4}>
            <Button variant="neutral" onClick={() => setThresholdMet(true)}>
              Back
            </Button>
            <Button onClick={() => props.onContinue(false)}>Continue</Button>
          </Flex>
        </>
      ) : (
        <Form
          key={JSON.stringify(props.initialValues)}
          initialValues={props.initialValues ?? initialValues}
          yupValidationSchema={ownerThresholdSchema}
          onSubmit={handleSubmit}
          submitOnlyChangedValues={false}
        >
          <OwnerThresholdFormContent
            entityName={props.entityName}
            thresholdPercentage={props.thresholdPercentage}
          />
          <Flex justifyContent="flex-end">
            <SubmitButton>Submit</SubmitButton>
          </Flex>
        </Form>
      )}
    </Flex>
  );
};
